import React from "react";
import "./About.scss";

export default function About() {
  return (
    <section id="about" className="section">
      <div className="container">
        <header className="section__head">
          <h2>Par klubu</h2>
          <h3 className="muted">Mēs esam viens no vadošajiem bērnu un jauniešu cīņas mākslu sporta klubiem!</h3>
          {/* <p>“Uzvarēsi sevi — uzvarēsi visu!”</p> */}
        </header>
        <div className="about__grid">
          <div className="about__card">
            <h3>“Uzvarēsi sevi — uzvarēsi visu!”</h3>
            <ul>
              <li> <b className="largeSize">💪</b> MŪSU MISIJA ir nodrošināt augstas kvalitātes treniņus drošā un atbalstošā vidē,
              palīdzēt bērniem augt par stipriem, drosmīgiem un mērķtiecīgiem cilvēkiem.</li>
              <li> <b className="largeSize">🧘🏻‍♂️</b>Mēs vēlamies, lai katrs bērns — no iesācēja līdz profesionālim —
              justos droši, atbalstīti un iedvesmoti attīstīties katru dienu,
              gan kā sportists, gan kā personība.</li>
              <li> <b className="largeSize">🏆</b>Mēs ticam, ka cīņas sports māca cieņu, disciplīnu,
              neatlaidību un pārliecību par sevi — vērtības, kas strādā visai dzīvei.</li>
              <li> <b className="largeSize">🥇</b>Mēs audzinām stiprus un mērķtiecīgus bērnus.

              Mūsdienu pasaule ir pilna izaicinājumu un kārdinājumu —
              tieši tāpēc sporta vide ir droša telpa attīstībai.</li>
            </ul>
            {/* <p>
              Mūsdienu pasaule ir pilna izaicinājumu un kārdinājumu —
              tieši tāpēc sporta vide ir droša telpa attīstībai.
            </p> */}
          </div>
          {/* <div className="about__card"> */}
            {/* <h3>“Uzvarēsi sevi — uzvarēsi visu!”</h3> */}
            {/* <ul>
              <li>Attīstīt disciplīnu un pašpārliecinātību</li>
              <li>Uzlabot mobilitāti un fizisko sagatavotību</li>
              <li>Veidot komandas garu</li>
            </ul> */}
            {/* <p>
              MŪSU MISIJA ir nodrošināt augstas kvalitātes treniņus drošā un atbalstošā vidē,
              palīdzēt bērniem augt par stipriem, drosmīgiem un mērķtiecīgiem cilvēkiem.

              Mēs vēlamies, lai katrs bērns — no iesācēja līdz profesionālim —
              justos droši, atbalstīti un iedvesmoti attīstīties katru dienu,
              gan kā sportists, gan kā personība.
            </p> */}
          {/* </div> */}
            {/* <p>
              Mēs ticam, ka cīņas sports māca cieņu, disciplīnu,
              neatlaidību un pārliecību par sevi — vērtības, kas strādā visai dzīvei.
            </p> */}
        </div>
      </div>
    </section>
  );
}
